import { openDB, type DBSchema, type IDBPDatabase } from 'idb';

export type OutboxKind = 'emergency' | 'crop';

export type OutboxItem = {
  /** The report's clientId (server de-duplicates on it). */
  id: string;
  kind: OutboxKind;
  /** API path, e.g. /emergency-reports */
  path: string;
  data: unknown;
  files: { field: string; blob: Blob; name: string }[];
  deviceId: string;
  title: string;
  createdAt: number;
  attempts: number;
  status: 'pending' | 'failed';
  lastError?: string;
};

/** A report this device submitted; the token lets guests follow it. Cached for offline viewing. */
export type MyReport = {
  ref: string;
  kind: OutboxKind;
  token: string;
  title: string;
  createdAt: number;
  /** Last known server state, for offline display. */
  snapshot?: unknown;
};

interface IliDB extends DBSchema {
  outbox: { key: string; value: OutboxItem };
  myReports: { key: string; value: MyReport };
  kv: { key: string; value: unknown };
}

let dbp: Promise<IDBPDatabase<IliDB>> | null = null;
export function idb(): Promise<IDBPDatabase<IliDB>> {
  dbp ??= openDB<IliDB>('ili', 1, {
    upgrade(db) {
      db.createObjectStore('outbox', { keyPath: 'id' });
      db.createObjectStore('myReports', { keyPath: 'ref' });
      db.createObjectStore('kv');
    },
  });
  return dbp;
}

export async function listMyReports(kind?: OutboxKind): Promise<MyReport[]> {
  const all = await (await idb()).getAll('myReports');
  return all.filter((r) => !kind || r.kind === kind).sort((a, b) => b.createdAt - a.createdAt);
}
export async function saveMyReport(r: MyReport): Promise<void> {
  await (await idb()).put('myReports', r);
}
export async function getMyReport(ref: string): Promise<MyReport | undefined> {
  return (await idb()).get('myReports', ref);
}
